import type { DefaultObject } from '@moniebook-web/types';
import { getBaseService } from '@moniebook-web/utils';

// Import a config
const ENABLE_MONITORING = process.env.ENABLE_MONITORING ?? 'true';
const GETTING_STARTED_VIDEOS_URL =
    process.env.GETTING_STARTED_VIDEOS_URL ??
    'https://teamapt.atlassian.net/wiki/spaces/MHC/pages/1839824965/Getting+Started+for+Businesses';

// Enables auto-checking of new application assets
const ENABLE_MANIFEST_POLLING = process.env.ENABLE_MANIFEST_POLLING ?? 'true';

// Customer analytics configs
const CUSTOMER_ANALYTICS_SERVICE = process.env.CUSTOMER_ANALYTICS_SERVICE ?? '';
const MIXPANEL_PROJECT_TOKEN = process.env.MIXPANEL_PROJECT_TOKEN ?? '';
const APPLICATION_ID = process.env.APPLICATION_ID ?? 'moniebook';
const ENVIRONMENT = process.env.ENVIRONMENT ?? 'development';
const MIXPANEL_RECORD_MASK_TEXT_SELECTOR =
    process.env.MIXPANEL_RECORD_MASK_TEXT_SELECTOR ?? '';
const MIXPANEL_RECORD_SESSION_PERCENT =
    process.env.MIXPANEL_RECORD_SESSION_PERCENT ?? '';
const MIXPANEL_RECORD_BLOCK_SELECTOR =
    process.env.MIXPANEL_RECORD_BLOCK_SELECTOR ?? '';
const CUSTOMER_ANALYTICS_ENVIRONMENT =
    process.env.CUSTOMER_ANALYTICS_ENVIRONMENT ?? 'dev';
// end customer analytics configs

// Braze configs
const BRAZE_API_KEY = process.env.BRAZE_API_KEY ?? '';
const BRAZE_BASE_URL = process.env.BRAZE_BASE_URL ?? '';
// end braze configs

// Support centre url configs
const HOW_TO_ADD_BRANCH_URL = process.env.HOW_TO_ADD_BRANCH_URL ?? '';
const HOW_TO_CREATE_CUSTOM_ROLE_URL =
    process.env.HOW_TO_CREATE_CUSTOM_ROLE_URL ?? '';
const HOW_TO_ADD_BRM_REFERRAL_CODE_URL =
    process.env.HOW_TO_ADD_BRM_REFERRAL_CODE_URL ?? '';
const GETTING_STARTED_WITH_MONIEBOOK_URL =
    process.env.GETTING_STARTED_WITH_MONIEBOOK_URL ?? '';
// end support centre url configs

const MONIEBOOK_BACKOFFICE_URL =
    process.env.MONIEBOOK_BACKOFFICE_URL ??
    'https://moniebook-backoffice.moniepoint.com';

// Inactivity duration configs
const MAXIMUM_INACTIVITY_DURATION_MINS =
    process.env.MAXIMUM_INACTIVITY_DURATION_MINS ?? '60';

// Moniedesk
const MONIEDESK_SELF_SERVICE = process.env.MONIEDESK_SELF_SERVICE ?? '';
const MONIEDESK_WEB_CHAT_APP = process.env.MONIEDESK_WEB_CHAT_APP ?? '';
const MONIEDESK_ENTITY_ID = process.env.MONIEDESK_ENTITY_ID ?? '';

const serviceUrl: DefaultObject = {
    ENABLE_MONITORING,
    ENVIRONMENT,
    GETTING_STARTED_VIDEOS_URL,
    CUSTOMER_ANALYTICS_SERVICE,
    MIXPANEL_PROJECT_TOKEN,
    APPLICATION_ID,
    MIXPANEL_RECORD_MASK_TEXT_SELECTOR,
    MIXPANEL_RECORD_BLOCK_SELECTOR,
    MIXPANEL_RECORD_SESSION_PERCENT,
    CUSTOMER_ANALYTICS_ENVIRONMENT,
    BRAZE_API_KEY,
    BRAZE_BASE_URL,
    HOW_TO_ADD_BRANCH_URL,
    HOW_TO_CREATE_CUSTOM_ROLE_URL,
    HOW_TO_ADD_BRM_REFERRAL_CODE_URL,
    GETTING_STARTED_WITH_MONIEBOOK_URL,
    MAXIMUM_INACTIVITY_DURATION_MINS,
    MONIEDESK_SELF_SERVICE,
    MONIEDESK_WEB_CHAT_APP,
    MONIEDESK_ENTITY_ID,
    MONIEBOOK_BACKOFFICE_URL,
    ENABLE_MANIFEST_POLLING,
};

const getService = getBaseService(serviceUrl);

export const config = {
    ENABLE_MONITORING: getService('ENABLE_MONITORING'),
    ENVIRONMENT: getService('ENVIRONMENT'),
    GETTING_STARTED_VIDEOS_URL: getService('GETTING_STARTED_VIDEOS_URL'),
    MONIEBOOK_BACKOFFICE_URL: getService('MONIEBOOK_BACKOFFICE_URL'),
    CUSTOMER_ANALYTICS_SERVICE: getService('CUSTOMER_ANALYTICS_SERVICE'),
    APPLICATION_ID: getService('APPLICATION_ID'),
    CUSTOMER_ANALYTICS_ENVIRONMENT: getService(
        'CUSTOMER_ANALYTICS_ENVIRONMENT',
    ),
    MAXIMUM_INACTIVITY_DURATION_MINS: getService(
        'MAXIMUM_INACTIVITY_DURATION_MINS',
    ),
    MIXPANEL: {
        token: getService('MIXPANEL_PROJECT_TOKEN'),
        track_pageview: false,
        record_sessions_percent: +(
            getService('MIXPANEL_RECORD_SESSION_PERCENT') ?? 0
        ),
        record_mask_text_selector: getService(
            'MIXPANEL_RECORD_MASK_TEXT_SELECTOR',
        ),
        record_block_selector: getService('MIXPANEL_RECORD_BLOCK_SELECTOR'),
    },
    BRAZE: {
        apiKey: getService('BRAZE_API_KEY'),
        baseUrl: getService('BRAZE_BASE_URL'),
    },
    SUPPORT_CENTRE: {
        howToAddBranch: getService('HOW_TO_ADD_BRANCH_URL'),
        howToCreateCustomRole: getService('HOW_TO_CREATE_CUSTOM_ROLE_URL'),
        howToAddBRMReferralCode: getService('HOW_TO_ADD_BRM_REFERRAL_CODE_URL'),
        gettingStartedWithMoniebook: getService(
            'GETTING_STARTED_WITH_MONIEBOOK_URL',
        ),
    },
    MONIEDESK: {
        selfServiceUrl: getService('MONIEDESK_SELF_SERVICE'),
        widgetHost: getService('MONIEDESK_WEB_CHAT_APP'),
        entityId: getService('MONIEDESK_ENTITY_ID'),
    },
    ENABLE_MANIFEST_POLLING: getService('ENABLE_MANIFEST_POLLING') === 'true',
};
